import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UserProfileModel } from '../../../core/models/classes/user-profile';
import { UserService } from '../../../core/services/user.service';
import { Role } from '../../../core/models/enums/user-role';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-userprofile',
  templateUrl: './userprofile.component.html',
  styleUrls: ['./userprofile.component.scss'],
})

export class UserprofileComponent implements OnInit {
  userProfile: UserProfileModel;
  status: string;
  buttonMode: string = '';
  roles: string[] = [];
  currentUserRole: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<UserprofileComponent>,
    private userService: UserService,
    private _snackBar: MatSnackBar
  ) {
    this.userProfile = new UserProfileModel();
  }

  ngOnInit(): void {
    if ('number' === typeof this.data) {
      this.buttonMode = $localize`CREATE`;
    } else {
      this.buttonMode = $localize`SAVE`;
      this.userProfile = this.data;
    }

    this.fetchUserRole();   
    if ('number' === typeof this.data)
    {
      this.getUserRoleWithID(this.data);     
    }
    else{
      this.getUserRoleWithID(this.data.userId);      
    }
  }

  getUserRoleWithID(uid: number){
    this.userService.getUserRole(uid).subscribe({
      next: (data) => {
        if (data === 1) {
          this.currentUserRole = 'SuperAdmin';
        } else if (data === 2) {
          this.currentUserRole = 'Admin';
        } else {
          this.currentUserRole = 'User';
        }
      },
    });
  }

  fetchUserRole(){
    const userId = this.userProfile.userId;  
    if(userId === undefined){ //create new profile scenario
      this.roles = ['Admin', 'User']; 
      this.userProfile.firstName = "";
      this.userProfile.lastName = "";
      this.userProfile.email = "";
      this.userProfile.company = "";
      this.currentUserRole = 'User';
    }
    this.userService.getUserRole(+userId).subscribe({
      next: (usr) => {         
        if(usr === 1){
          this.roles = ['SuperAdmin'];
        }
        else{
          this.roles = ['Admin', 'User'];
        }       
      },
    });
  }

  createNewProfile(): void {    
    var isValid = false;
    if(this.userProfile.firstName !== "" && this.userProfile.lastName !== "" 
      && this.userProfile.email !== "" && this.userProfile.company !== "" && this.currentUserRole !== '' &&
      this.userProfile.firstName !== null && this.userProfile.lastName !== null 
      && this.userProfile.email !== null && this.userProfile.company !== null){       
      isValid = true;
    }
    else{
      this._snackBar.open($localize `Fields cannot be empty`, '', {
        duration: 3000
      });
    }

    if(isValid){       
      if ('number' === typeof this.data) //add new user
      {
        this.addNewUser();
      } 
      else //edit existing user
      {      
        this.editUser();
        this.updateUser();       
      }
    }
  }

  updateUser(){
    this.userService
    .editUserProfile(Object.values(this.userProfile)[0], this.userProfile)
    .subscribe({
      next: (data) => {
        this.status = 'Successfully added';
        this._snackBar.open($localize `Profile updated successfully`, '', {
          duration: 3000
        });
        this.dialogRef.close();
      },
      error: (err) => {
        this.status = 'No Permission';
        {
          throw Error(err.Status);
        }
      },
    });
  }

  editUser(){
    this.userProfile = this.data;         
    this.userService.getUser(this.data.userId).subscribe({
      next: (data) => {     
        var role = 3; //by default, Role is User
        if(this.currentUserRole !== undefined){
          role = Role[this.currentUserRole];
        }                      
        data.roleId = role;                  
        this.userService.updateUserRole(this.data.userId,data).subscribe({
          next:(data)=>{
            if(data.status === 200){                  
              this._snackBar.open($localize `User role updated successfully`, '', {
                duration: 3000
              });
            }
          }
        })
      },
    });
  }

  addNewUser(){
    this.userProfile.userId = this.data;
    this.userService.addNewProfile(this.userProfile).subscribe({
      next: (data) => {
        if (data.status === 200) {                           
          this.userService.getUser(this.userProfile.userId).subscribe({
            next: (data) => {                           
              var role = Role[this.currentUserRole];                                
              data.roleId = role;                         
              this.userService.updateUserRole(data.id,data).subscribe({
                next:(data)=>{}
              })
            },
          });

          this._snackBar.open($localize `Profile added successfully`, '', {
            duration: 3000
          });
          this.dialogRef.close();
        }
      },
    });      
  }

  selectedRole(value: any) {
    this.currentUserRole = value;
  }
}